import { Stack, useLocalSearchParams } from 'expo-router';
import { Platform, View } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import { usePublicReservation } from '@/api/reservations/use-public-reservation';
import { RentalAgreementView } from '@/components/rental-agreement';
import { isDesktop } from '@/core';
import { Loader } from '@/ui/loader';

export default function PublicRentalAgreement() {
  const { theme } = useStyles();
  const { id, public_token } = useLocalSearchParams<{
    id: string;
    public_token: string;
  }>();

  const { data: resData, isPending } = usePublicReservation({
    variables: { id, publicToken: public_token },
    enabled: !!id && !!public_token,
  });

  if (isPending) {
    return (
      <View
        style={{
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: theme.colors.background_1,
        }}
      >
        <Loader style={{ height: 150, width: 150 }} />
      </View>
    );
  }

  return (
    <>
      {isDesktop() && Platform.OS === 'web' ? (
        <Stack.Screen options={{ headerShown: false }} />
      ) : (
        <Stack.Screen
          options={{
            title: 'Rental Agreement',
            headerTitle: 'Rental Agreement',
            headerShown: true,
            headerLeft: () => null,
            headerStyle: { backgroundColor: theme.colors.background_1 },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
          }}
        />
      )}

      {resData ? (
        <RentalAgreementView
          resData={resData}
          resId={id}
          showBackButton={false}
        />
      ) : null}
    </>
  );
}
